import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {i_more, i_reply} from "../../../icons";
import {
  formatErrors,
  months,
  msgDirectionAiToUser,
  msgDirectionBotToClient,
  msgDirectionClientToUser,
  msgDirectionNoteToClient, msgDirectionSystemToUser,
  msgDirectionUserToClient, msgTypeMessage, UPDATE_CHAT_EDIT_MESSAGE, UPDATE_CHAT_REMOVE_MESSAGE, UPDATE_CHAT_REPLY_MESSAGE, userPrintName,
  newAiUiEnabled, isAiCreated, aiCreatedTitle,
  SUPPORT_USER_ID, roleTechnicalSpecialist
} from "../../../constants";
import {chatMessageRemoveAction, chatMessageAddAction, chatMessageToSupportAction} from "../../../actions/chatAction";
import cfg from "../../../constants";
import {FilePreview} from "../../../utils/filePreview/FilePreview";
import { toast } from 'react-toastify';

export function ChatMessage({item, curator, prev, hideMessagesFromBot}) {
  const [className, setClassName] = useState('');
  const client = useSelector(state => state.chat.client);
  const user = useSelector(state => state.user.profile);
  const dispatch = useDispatch();

  // Сообщение из потока службы заботы. Поток различается владельцем переписки:
  // признака «это забота» на самом сообщении нет и не нужно.
  const fromCare = item.users_id === SUPPORT_USER_ID;
  // У службы заботы поток один, и красить в нём нечего — а вот куратор видит оба
  // и должен видеть, где чей: он отвечает за программу, а не за оплату.
  const inCareView = user && user.role_id === roleTechnicalSpecialist;
  const careInOwnFeed = fromCare && !inCareView;
  // Сообщение написала клиентка. Классы в вёрстке названы наоборот — её
  // сообщение это `chat__item--me`, а своё у куратора `--from`, — поэтому
  // отличаем по направлению, а не по классу
  const fromClient = item.message_direction === msgDirectionClientToUser;
  // Передавать можно только вопрос клиентки и только из приложения: потока
  // службы заботы у остальных каналов нет вовсе
  const canTransfer = !inCareView && !fromCare && client && client.channel_type === 'O' && fromClient;
  // Пустое меню — кнопка, которая ничего не открывает. На клиентской реплике в
  // меню бывает один пункт, и если передавать некуда (не приложение, или это уже
  // поток заботы), показывать ⋮ незачем
  const hasMenu = !fromClient || canTransfer;

  useEffect(() => {
    let cls = [];
    if (item.message_direction === msgDirectionClientToUser || item.message_direction === msgDirectionSystemToUser) {
      cls.push('chat__item--me');
    } else if (item.message_direction === msgDirectionBotToClient) {
      cls.push('chat__item--from');
      cls.push('js-item-chat');
      if(!hideMessagesFromBot || !item.hideBotMsg){
        cls.push('open');
        }
    } else if (item.message_direction === msgDirectionNoteToClient) {
      cls.push('chat__item--note');
    } else {
      cls.push('chat__item--from');
      cls.push('js-item-chat');
      cls.push('open');
    }
    if ((item.message_direction === msgDirectionClientToUser || item.message_direction === msgDirectionSystemToUser) && !item.read_status) {
      cls.push('chat__item--bold');
    }
    if (newAiUiEnabled() && isAiCreated(item)) {
      cls.push('chat__item--ai');
    }
    if (careInOwnFeed) {
      cls.push('chat__item--care');
    }
    setClassName(cls.length > 0 ? ' ' + cls.join(' ') : '');
  }, [item, item.read_status, hideMessagesFromBot, careInOwnFeed]);

  const handleChange = () => {
    dispatch({type: UPDATE_CHAT_EDIT_MESSAGE, message: item});
  };

  const handleReply = () => {
    dispatch({type: UPDATE_CHAT_REPLY_MESSAGE, message: item});
  };

  const handleDelete = () => {
    dispatch(chatMessageRemoveAction(item.id));
  };

  const handleToSupport = () => {
    dispatch(chatMessageToSupportAction(item.id)).then(() => {
      toast.success('Вопрос передан в службу заботы', {position: toast.POSITION.BOTTOM_RIGHT});
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const handleAccept = () => {
    dispatch(chatMessageAddAction(client.id, item.chat_id, msgTypeMessage, item.message, null, item.id, null, false)).then(() => {
      dispatch({type: UPDATE_CHAT_REMOVE_MESSAGE, message_id: item.id});
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const handleDecline = () => {
    dispatch(chatMessageAddAction(client.id, item.chat_id, msgTypeMessage, item.message, null, item.id, null, true)).then(() => {
      dispatch({type: UPDATE_CHAT_REMOVE_MESSAGE, message_id: item.id});
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  };

  const hideShowBotMsg = (item, hideBotMsg) => {
    item.hideBotMsg = hideBotMsg;
    
    let cls = [];
    if (item.message_direction === msgDirectionClientToUser || item.message_direction === msgDirectionSystemToUser) {
      cls.push('chat__item--me');
    } else if (item.message_direction === msgDirectionBotToClient) {
      cls.push('chat__item--from');
      cls.push('js-item-chat');
      if(!hideMessagesFromBot || !item.hideBotMsg){
        cls.push('open');
        }
    } else if (item.message_direction === msgDirectionNoteToClient) {
      cls.push('chat__item--note');
    } else {
      cls.push('chat__item--from');
      cls.push('js-item-chat');
      cls.push('open');
    }
    if ((item.message_direction === msgDirectionClientToUser || item.message_direction === msgDirectionSystemToUser) && !item.read_status) {
      cls.push('chat__item--bold');
    }
    if (newAiUiEnabled() && isAiCreated(item)) {
      cls.push('chat__item--ai');
    }
    if (careInOwnFeed) {
      cls.push('chat__item--care');
    }
    setClassName(cls.length > 0 ? ' ' + cls.join(' ') : '');
  };

  var pathId = item.chat_id;
  var nameFile = item.file;

  if(item.users_id_bulk_mailing){
    pathId = item.users_id_bulk_mailing;
    nameFile = item.file_bulk_mailing;
  }

  return <React.Fragment>
    <ChatMessageDate date={item.created} prevDate={prev ? prev.created : null}/>
    <div className={"chat__item" + className}>
      {item.reply_to_message_id && <ChatMessageReplied user={user} client={client} curator={curator} message={item.reply_to_message} />}
      <ChatMessageAuthor item={item} user={user} client={client} curator={curator ? curator : user} care={careInOwnFeed}/>
      <div className="chat__text">
        
        {item.message_direction === msgDirectionBotToClient && <div className="chat__overlay js-item-chat__btn" title="Показать сообщение" onClick={() => hideShowBotMsg(item, false)}></div>}
        {item.message_direction === msgDirectionBotToClient && <div className="chat__arrow js-item-chat__close" title="Скрыть" onClick={() => hideShowBotMsg(item, true)}><svg><use xlinkHref="#chevron"></use></svg></div>}
        
        <div className="chat__message">
          <ChatMessageText message={item.message}/>
          {nameFile && <FilePreview file={nameFile} url={item.file_url} messageId={item.id}
                                    path={cfg.public_url + 'auth/file/' + pathId + '/i/'}/>}
        </div>
        <ChatMessageTime date={item.created}/>
        {item.message_direction === msgDirectionClientToUser && !careInOwnFeed &&
          <span className="chat__reply pointer" onClick={handleReply}>
          {i_reply()}
        </span>}
        {/* В чужом потоке куратор ничего не делает: ни отвечает, ни правит, ни
            удаляет. Он видит его для контекста — чтобы не спрашивать у клиентки
            то, что она уже рассказала службе заботы */}
        {user && !careInOwnFeed && hasMenu && <button className="chat__more">
          {i_more()}
          <ul className="dropdown dropdown--top-left">
            {/* Правка и удаление — только для сказанного сотрудником. Чужие
                слова куратор не переписывает: клиентка потом не поймёт, почему
                её сообщение звучит иначе, чем она его писала */}
            {!fromClient && <li className="dropdown__item" onClick={handleChange}>Изменить</li>}
            {!fromClient && <li className="dropdown__item" onClick={handleDelete}>Удалить</li>}
            {canTransfer && <li className="dropdown__item" onClick={handleToSupport}>Передать в службу заботы</li>}
          </ul>
        </button>}
      </div>
      {!newAiUiEnabled() && item.message_direction === msgDirectionAiToUser &&
        <div className="chat__actions">
          <button type="button" className="btn" onClick={() => handleAccept()}>Принять</button>
          <button type="button" className="btn btn-red" onClick={() => handleDecline()}>Отклонить</button>
        </div>
      }
    </div>
  </React.Fragment>;
}

export function ChatMessageReplied({message, curator, client, user}) {
  var pathId = message.chat_id;
  var nameFile = message.file;

  if(message.users_id_bulk_mailing){
    pathId = message.users_id_bulk_mailing;
    nameFile = message.file_bulk_mailing;
  }

  return <div className="chat__replied">
    <ChatMessageAuthor item={message} user={user} client={client} curator={curator ? curator : user}/>
    <div className="chat__text">
      <div className="chat__message">
        <ChatMessageText message={message.message}/>
        {nameFile && <FilePreview file={nameFile} url={message.file_url} messageId={message.id}
                                  path={cfg.public_url + 'auth/file/' + pathId + '/i/'}/>}
      </div>
    </div>
  </div>;
};

export function ChatMessageText({message}) {
  return <React.Fragment>
    {
      message.split("\n").map((i, k) => <React.Fragment key={k}>{i}<br /></React.Fragment>)
    }
  </React.Fragment>;
};

function ChatMessageDate({date, prevDate}) {
  const [dateFormatted, setDateFormatted] = useState(null);

  useEffect(() => {
    const dt = new Date(date.replace('Z', ''));
    const dtPref = prevDate ? new Date(prevDate.replace('Z', '')) : null;
    if (!dtPref || dtPref.getFullYear() !== dt.getFullYear() || dtPref.getMonth() !== dt.getMonth() || dtPref.getDate() !== dt.getDate()) {
      const now = new Date();
      if (dt.getFullYear() !== now.getFullYear()) {
        setDateFormatted(dt.getDate() + ' ' + months[dt.getMonth()] + ' ' + dt.getFullYear());
      } else {
        setDateFormatted(dt.getDate() + ' ' + months[dt.getMonth()]);
      }
    } else {
      setDateFormatted(null);
    }
  }, [date, prevDate]);

  if (!dateFormatted) {
    return null;
  }
  return <div className="chat__data">{dateFormatted}</div>;
}

function ChatMessageAuthor({item, client, user, curator, care}) {
  // Плашка потока: в ленте куратора сообщения службы заботы должны быть видны с
  // первого взгляда, иначе он отвечает на вопрос про оплату как на свой
  const careBadge = care
    ? <span className="chat__care-badge" title="Переписка со службой заботы">Служба заботы</span>
    : null;

  if (item.message_direction === msgDirectionSystemToUser) {
    return null;
  }
  if (item.message_direction === msgDirectionClientToUser) {
    if (!client) {
      return <div className="chat__author">-{careBadge}</div>;
    }
    return <div className="chat__author">{client.first_name} {client.last_name}{careBadge}</div>
  }
  if (item.message_direction === msgDirectionNoteToClient) {
    return <div className="chat__author">Заметка</div>;
  }
  if (item.message_direction === msgDirectionBotToClient) {
    return <div className="chat__author">Бот</div>;
  }
  if (care) {
    // В потоке заботы отвечает не куратор чата, и подписывать сообщение его
    // именем нельзя: клиентке отвечал другой человек
    return <div className="chat__author">Служба заботы{careBadge}</div>;
  }
  if (curator) {
    return <div className="chat__author">
      {curator.print_name ? curator.print_name : userPrintName(curator)}
      {newAiUiEnabled() && isAiCreated(item) && <span className="chat__ai-badge" title={aiCreatedTitle(item)}>AI</span>}
    </div>;
  }
  return <div className="chat__author">-</div>;
}

function ChatMessageTime({date}) {
  const [dateFormatted, setDateFormatted] = useState({
    time: ''
  });

  useEffect(() => {
    const dt = new Date(date.replace('Z', ''));
    setDateFormatted({
      time: ('0' + dt.getHours()).slice(-2) + ':' + ('0' + dt.getMinutes()).slice(-2)
    })
  }, [date]);

  return <span className="chat__time">{dateFormatted.time}</span>;
}
